import { FiSearch } from "react-icons/fi"
import { useSelector } from 'react-redux'
import GeneralButton from '../../components/button/GeneralButton'
import FormInput from '../../components/formInput/FormInput'
import AllowedManufacturerModal from '../../components/modals/AllowedManufacturerModal'
import AllowedManufacturersTable from '../../components/table/AllowedManufacturersTable'
import useAllowedManufacturersHook from './customHooks/useAllowedManufacturersHook'

import { Spin } from "antd"

const AllowedManufacturers = () => {
    const {
        allowedManufacturers,
        modalOpen,
        selectedItem,
        toggleModal,
        handleDelete,
        handleEdit,
        handleAddNew,
        searchValue,
        setSearchValue,
        loading,
    } = useAllowedManufacturersHook()

    const { all_manufacturers } = useSelector((state) => state.redux);

    // Create a map for quick manufacturer name lookup
    const manufacturersMap = all_manufacturers?.reduce((acc, mfg) => {
        acc[mfg._id] = mfg.name;
        return acc;
    }, {}) || {};

    return (
        <div className="settings-container">
            <AllowedManufacturerModal
                modal={modalOpen}
                toggle={toggleModal}
                selectedItem={selectedItem}
            />

            <div className="px-4">
                <div className="d-flex justify-content-between align-items-center mb-4 search-input-wrapper">
                    <div style={{ width: "400px" }}>
                        <FormInput
                            type="text"
                            placeholder="Search DNH Vendor Name..."
                            size="large"
                            className="border-0 shadow-none"
                            icon={<FiSearch size={20} className="text-muted" />}
                            value={searchValue}
                            handleChange={(e) => setSearchValue(e.target.value)}
                        />
                    </div>
                    <GeneralButton
                        title={"Add Allowed Manufacturer"}
                        className={"create-user-btn text-white shadow-sm px-4"}
                        handleClick={handleAddNew}
                    />
                </div>

                <div className="settings-card">
                    {loading ? (
                        <div className="text-center py-5">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <AllowedManufacturersTable
                            data={allowedManufacturers}
                            handleDelete={handleDelete}
                            onEdit={handleEdit}
                            manufacturersMap={manufacturersMap}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default AllowedManufacturers
